"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyOpacityToColor = exports.getPresetColorsForProperty = exports.PropertyControls = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var colord_1 = require("colord");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ClientColorProvider_1 = require("DreamCoat/ClientColorProvider");
var styles = __importStar(require("./PropertyControls.css"));
var PropertyControls = function (_a) {
    var _b;
    var property = _a.property, style = _a.style, element = _a.element, onChangeHandler = _a.onChangeHandler, onSliderMouseDown = _a.onSliderMouseDown;
    var colorProvider = (0, ClientColorProvider_1.useColorProvider)();
    if (property.if && !property.if(style, element)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (property.type === "color") {
        var colorStyle_1 = (0, lodash_1.get)(style, property.path);
        var color = (0, GetBlockStyle_1.convertColorObjToColor)(colorStyle_1);
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", className: styles.colorPalette({ hugPreviousControl: property.hugPreviousControl }) },
            react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark", size: "s", hidden: property.labelHidden }, property.label),
            react_1.default.createElement(ColorPalette_1.default, { key: property.path, onColorChange: function (color) {
                    var _a;
                    var colorObj = __assign(__assign({}, colorStyle_1), (0, GetBlockStyle_1.convertColorToColorObj)(color));
                    if (property.opacity) {
                        colorObj.abs = (0, exports.applyOpacityToColor)(colorObj, (_a = colorObj.opacity) !== null && _a !== void 0 ? _a : property.opacity.defaultValue);
                    }
                    onChangeHandler(property, colorObj);
                }, presetColors: (0, exports.getPresetColorsForProperty)(property, colorProvider), selectedColor: property.opacity ? __assign(__assign({}, color), { value: (0, exports.applyOpacityToColor)(color, 1) }) : color, type: "content" }),
            property.opacity && (react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: function (value) {
                    var nextColor = (0, lodash_1.cloneDeep)(colorStyle_1);
                    var nextOpacity = value / 100;
                    nextColor.opacity = nextOpacity;
                    nextColor.abs = (0, exports.applyOpacityToColor)(colorStyle_1, nextOpacity);
                    onChangeHandler(property, nextColor);
                }, theme: kaleidoscope_1.SliderTheme.Dark, label: property.opacity.label, unit: "%", initialInputValue: Math.floor(((_b = (0, lodash_1.get)(style, property.path).opacity) !== null && _b !== void 0 ? _b : property.opacity.defaultValue) * 100), minimum: 0, maximum: 100, sliderEventHandlers: {
                    onMouseDown: onSliderMouseDown,
                } }))));
    }
    if (property.type === "numerical") {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: function (value) { return onChangeHandler(property, value); }, theme: kaleidoscope_1.SliderTheme.Dark, label: property.label, unit: property.suffix, initialInputValue: (0, lodash_1.get)(style, property.path), maximum: property.max, minimum: property.min, sliderEventHandlers: {
                    onMouseDown: onSliderMouseDown,
                } })));
    }
    if (property.type === "enumerable") {
        return (react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: property.label, size: kaleidoscope_1.SegmentedControlSize.Medium, options: property.options
                .filter(function (o) { return !o.if || o.if(style); })
                .map(function (_a) {
                var Icon = _a.icon, option = __rest(_a, ["icon"]);
                return (__assign(__assign({}, option), (!!Icon ? { icon: react_1.default.createElement(Icon, null) } : {})));
            }), selectedValue: (0, lodash_1.get)(style, property.path), onClickHandler: function (tokenValue) { return onChangeHandler(property, tokenValue); } }));
    }
    if (property.type === "alignable") {
    }
    if (property.type === "textLabel") {
        return (react_1.default.createElement(kaleidoscope_1.TextInput, { theme: "dark", label: property.label, placeholder: property.defaultValue, value: (0, lodash_1.get)(style, property.path), onChange: function (value) { return onChangeHandler(property, value); }, maxLength: 50, onFocus: function () {
            }, onBlur: function () {
            } }));
    }
    if (property.type === "fontSize") {
    }
    if (property.type === "boolean") {
        return (react_1.default.createElement(kaleidoscope_1.Toggle, { label: property.label, value: (0, lodash_1.get)(style, property.path, property.defaultValue), onChange: function (nextValue) { return onChangeHandler(property, nextValue); }, theme: "dark" }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.PropertyControls = PropertyControls;
var getPresetColorsForProperty = function (property, colorProvider) {
    var _a;
    if (typeof property.presetColors === "undefined") {
        return colorProvider.themeColors;
    }
    var baseColors = [];
    switch (property.presetColors.type) {
        case "filteredThemeColors": {
            baseColors = colorProvider.filteredThemeColors;
            break;
        }
        case "fixed": {
            return property.presetColors.colors;
        }
        case "themeColors": {
            baseColors = colorProvider.themeColors;
            break;
        }
    }
    var allColors = __spreadArray(__spreadArray([], __read(baseColors), false), __read(((_a = property.presetColors.additionalColors) !== null && _a !== void 0 ? _a : [])), false);
    var uniqueColors = (0, lodash_1.uniqBy)(allColors, function (c) { return (0, colord_1.colord)(c.value).toRgbString(); });
    return uniqueColors;
};
exports.getPresetColorsForProperty = getPresetColorsForProperty;
var applyOpacityToColor = function (color, opacity) {
    var colorValue = "abs" in color ? color.abs : color.value;
    return (0, colord_1.colord)(colorValue).alpha(opacity).toRgbString();
};
exports.applyOpacityToColor = applyOpacityToColor;
